import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CogsImpactChartData } from '../../interfaces';
import { CHART_NO_TOOLBAR_CONFIG } from '../plotly-chart-config';

export interface CogsTreemapNode {
  label: string;
  percentEntry: number
}
@Component({
  selector: 'app-cogs-treemap-chart',
  standalone: false,
  templateUrl: './cogs-treemap-chart.component.html',
  styleUrl: './cogs-treemap-chart.component.scss'
})
export class CogsTreemapChartComponent implements OnChanges {
  @Input() data!: CogsImpactChartData[];
  @Output() clickedOnNodeEvent = new EventEmitter<CogsTreemapNode>();

  @ViewChild('chart') chart!: ElementRef;
  title = 'plotly-treemap-example';

  public graph = {
    data: [
      {
        type: 'treemap',
        labels: [] as string[],
        parents: [] as string[],
        values: [] as number[],
        level: '' as string,
        customdata: [] as number[][],
        texttemplate: '<br><b>&nbsp;%{label}</b><br><br>&nbsp;COGS Change: %{customdata[1]:.2f} USD (%{customdata[0]:.2f}%)<br>&nbsp;COGS Impact: %{customdata[2]:.2f}M USD',
        hovertemplate: '<b>%{label}</b><br><br>COGS Change: %{customdata[1]:.2f} USD (%{customdata[0]:.2f}%)<br>COGS Impact: %{customdata[2]:.2f}M USD<extra></extra>',
        textfont: {
            color: [] as string[],
            size: 12
        },
        marker: {
            colors: [] as string[],
            showscale: false,
            line: {
                width: 2,
                color: 'white'
            }
        },
      }
    ],
    layout: {
      title: 'Sample Plotly Treemap',
      height: 350,
      autosize: true,
      margin: {
        l: 0,             // Remove left margin
        r: 0,             // Remove right margin
        t: 5,            // Keep some top margin for title
        b: 0,             // Remove bottom margin
        pad: 0            // Remove padding
      },
      paper_bgcolor: 'rgba(0,0,0,0)',  // Transparent background
      plot_bgcolor: 'rgba(0,0,0,0)',   // Transparent plot area
    },
    config: CHART_NO_TOOLBAR_CONFIG
  };

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['data'] && changes['data'].currentValue) {
      const currentLength = changes['data'].currentValue.length;
      const previousLength = changes['data'].previousValue?.length || 0;
      if (currentLength !== previousLength) {
        this.resetChartLevel();
      }
    }
    
    this.graph.data[0].labels = this.data.map((elem) => elem.label);
    this.graph.data[0].parents = this.data.map(elem => elem.parent);
    this.graph.data[0].values = this.data.map(elem => elem.size);
    this.graph.data[0].customdata = this.data.map(elem => [elem.value * 100, elem.cogsChange, elem.cogsImpact]);
    
    const colorPalette = ['#063970', '#2596be', '#ffc340', '#e28000'];

    const colors = this.data.map(elem => {
        if (elem.value < -0.05) return colorPalette[0];
        else if (elem.value < 0) return colorPalette[1];
        else if (elem.value < 0.05) return colorPalette[2];
        else return colorPalette[3];
    });

    const textColors = colors.map(color => this.getContrastingColor(color));

    this.graph.data[0].marker.colors = colors;
    this.graph.data[0].textfont.color = textColors;
}

  getContrastingColor(hexColor: string): string {
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);

    const brightness = (r * 299 + g * 587 + b * 114) / 255000;

    return brightness >= 0.5 ? 'black' : 'white';
  }

  handleTreemapClick(event: any) {
    if (event && event.points && event.points.length > 0) {
      const clickedPoint = event.points[0];
      const treemapNode = {
        label: clickedPoint.label,
        percentEntry: clickedPoint.percentEntry
      } as CogsTreemapNode;
      this.clickedOnNodeEvent.emit(treemapNode);
    }
  }

  private resetChartLevel(): void {
    this.graph.data[0].level = '';
  }
}
